export const MIN_HOTEL_ROOMS_NUM = 1
export const MAX_HOTEL_ROOMS_NUM = 20

export const clampHotelRoomsNum = (value: unknown): number => {
  const parsed = Math.max(MIN_HOTEL_ROOMS_NUM, Number(value) || MIN_HOTEL_ROOMS_NUM)
  return Math.min(MAX_HOTEL_ROOMS_NUM, parsed)
}

type HotelGuestFormSearch = {
  roomsNum?: number
  adults?: number
}

export const normalizeHotelGuestCounts = (formSearch: HotelGuestFormSearch): void => {
  const roomsNum = clampHotelRoomsNum(formSearch.roomsNum)
  formSearch.roomsNum = roomsNum
  formSearch.adults = Math.max(formSearch.adults || roomsNum, roomsNum)
}

type GuestCountLabels = {
  adult: string
  child: string
}

export const formatHotelGuestCount = (
  adults: number,
  children: number,
  labels: GuestCountLabels,
): string => {
  const parts: string[] = []

  if (adults > 0) {
    parts.push(`${adults} ${labels.adult}`)
  }

  if (children > 0) {
    parts.push(`${children} ${labels.child}`)
  }

  return parts.join(", ")
}

type HotelGuestBooking = {
  adults?: number
  children?: number
  roomsNum?: number
  checkInDate?: string
  checkOutDate?: string
}

/** Gắn số khách/phòng từ form search lên object hotel (itinData / API echo). */
export const mergeHotelGuestCriteria = <T extends Record<string, unknown>>(
  hotel: T,
  booking: HotelGuestBooking,
): T & HotelGuestBooking & { adt?: number; child?: number; room?: number; in?: string; out?: string } => {
  const roomsNum = clampHotelRoomsNum(booking.roomsNum ?? (hotel.room as number | undefined))
  const adults = Math.max(booking.adults ?? (hotel.adt as number | undefined) ?? roomsNum, roomsNum)
  const children = booking.children ?? (hotel.child as number | undefined)
  const checkIn = booking.checkInDate || (hotel.in as string | undefined)
  const checkOut = booking.checkOutDate || (hotel.out as string | undefined)

  return {
    ...hotel,
    adults,
    children,
    roomsNum,
    adt: adults,
    child: children,
    room: roomsNum,
    in: checkIn,
    out: checkOut,
  }
}
